"use client";

import React, { useEffect, useState, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { fetchBookingsByDomeAndDate } from "../../api/booking.api";

const DomeBookings = () => {
  const { domeid: domeId } = useParams();
  //   console.log("🚀 ~ DomeBookings ~ domeId:", domeId)
  const location = useLocation();
  const domeData = location.state?.domeData || null;
  //   console.log("🚀 ~ DomeBookings ~ domeData:", domeData)

  const { background } = useContext(ThemeContext);
  const isDark = background === "dark";

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateFilter, setDateFilter] = useState("");
  const [error, setError] = useState(null);

  /* ---------------------- FETCH BOOKINGS ---------------------- */
  const loadBookings = async (selectedDate = "") => {
    try {
      setLoading(true);
      const data = await fetchBookingsByDomeAndDate(domeId, selectedDate || "");
      console.log("🚀 ~ loadBookings ~ data:", data);
      setBookings(data.bookings || []);
    } catch (err) {
      console.error("Error fetching bookings:", err);
      setError("Failed to load bookings. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------- INITIAL + FILTER ---------------------- */
  useEffect(() => {
    loadBookings(dateFilter);
  }, [domeId, dateFilter]);

  return (
    <div className="container-fluid py-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 mb-3">
          Bookings for{" "}
          <span className="text-primary">{domeData?.domeName || "N/A"}</span>
        </h4>

        {/* Date Filter */}
        <div className="d-flex gap-2 mb-3 align-items-center">
          <input
            type="date"
            className="form-control"
            style={{ width: "200px", fontSize: "14px", borderRadius: "5px" }}
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
          {dateFilter && (
            <button
              className="btn btn-outline-secondary"
              style={{ fontSize: "13px" }}
              onClick={() => setDateFilter("")}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Error State */}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      {/* Table */}
      {!loading && !error && (
        <div className="table-responsive shadow-sm rounded">
          <table
            className={`table align-middle mb-0 ${
              isDark ? "table-dark table-striped" : "table-striped"
            }`}
          >
            <thead className={`${isDark ? "bg-secondary" : "bg-light"}`}>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Session</th>
                <th>Start Time</th>
                <th>Duration</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {bookings?.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-muted">
                    <i className="fas fa-calendar-times me-2"></i>No bookings
                    found.
                  </td>
                </tr>
              ) : (
                bookings?.map((booking, index) => (
                  <tr key={booking._id}>
                    <td>{index + 1}</td>
                    <td>{booking?.name || "Guest"}</td>
                    <td>{booking?.email || "N/A"}</td>
                    <td>{booking?.phone || "N/A"}</td>
                    <td>{booking.sessionRef?.name || "N/A"}</td>
                    <td>{booking.sessionRef?.startTime || "N/A"}</td>
                    <td>{booking.sessionRef?.duration || "N/A"}</td>
                    <td>
                      {new Date(booking.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DomeBookings;
